import { Switch } from "@/components/ui/switch";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { useId } from "react";
import { useFieldPresenceContext } from "./field-presence.context";

/**
 * Échappatoire à l'affichage filtré.
 *
 * Par défaut le drawer ne propose que des champs renseignés (`showAllFields`
 * à false). Sans ce bouton, un utilisateur qui cherche « Technique » sur une
 * sélection où personne ne l'a saisie conclurait que l'option a disparu de
 * l'application. Le bascule ne dure que le temps du drawer ouvert.
 */
export function ShowAllFieldsToggle() {
  const vt = useVisibleT();
  const { showAllFields, setShowAllFields, isLoading } =
    useFieldPresenceContext();
  const id = useId();

  return (
    <div className="flex items-center gap-2">
      <Switch
        id={id}
        checked={showAllFields}
        onCheckedChange={setShowAllFields}
        // Pendant le calcul tout est déjà affiché : basculer ne ferait rien
        // de visible, et donnerait l'impression que le bouton ne marche pas.
        disabled={isLoading}
      />
      <label htmlFor={id} className="text-sm font-normal cursor-pointer">
        {vt("bo.print.showAllFields", "Afficher tous les champs")}
      </label>
    </div>
  );
}
